<template>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary" style="position: sticky; top: 0; z-index: 1">
                <v-btn icon dark @click="Close" :loading="loading"><v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title>Mapa de Beneficiários</v-toolbar-title>
            </v-toolbar>

            <v-card-text class="pa-2">
                <div id='map' style='width: 100%; height: 90dvh;'></div>
            </v-card-text>
        </v-card>

        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </v-dialog>

</template>

<script>
import BeneficiarioService from '../../core/services/projetos/BeneficiarioService';

export default {
    props:{
        value: {},
        item: {}
    },
    watch: { 
        value: function() {
            this.dialog = this.value;
        },
        dialog:  function() {
            if(this.dialog){
                this.CarregarCoordenadas();
            }
            else {
                this.$emit('fechou');
            }
        }
    },
    data: () => ({
        service: new BeneficiarioService(),
        dialog: false,
        loading: false,
        features: []
    }),
    methods: {
        CarregarCoordenadas(){
            this.item.forEach(x => {
                let feature = {
                    type: 'Feature',
                    properties: {
                        description: `${x.id} - ${x.nome}`,
                    },
                    geometry: {
                        type: 'Point',
                        coordinates: [x.longitude, x.latitude]
                    }
                }
                this.features.push(feature);
            })
            setTimeout(() => {
                this.CarregarMapa();
                this.loading = false;
            }, 1000);
        },
        CarregarMapa(){
            mapboxgl.accessToken = 'pk.eyJ1Ijoic2NpYW1tYXJlbGxhYnJlbm5vIiwiYSI6ImNrbTBtcWxidTBpZWkybm1yYXpndTg4ZHQifQ.P1PbWu6ZPZVNL6Vj8DPK1A';
            
            const initialPos = this.item.length == 1 ? [this.item[0].longitude, this.item[0].latitude] : [-53.5793201, -13.861785];
            const initialZoom = this.item.length == 1 ? 14 : 3;
            
            const map = new mapboxgl.Map({
                container: 'map',
                style: 'mapbox://styles/mapbox/standard', // style URL
                center: initialPos, // starting position [lng, lat]
                zoom: initialZoom, // starting zoom
            });
            
            map.on('load', () => {
                map.addSource('dot-point', {
                    'type': 'geojson',
                    'data': {
                        'type': 'FeatureCollection',
                        'features': this.features
                    }
                });
                
                map.addLayer({
                    'id': 'layer-with-pulsing-dot',
                    'type': 'circle',
                    'source': 'dot-point',
                    'paint': {
                        'circle-radius': 6,
                        'circle-color': '#B42222'
                    }
                });
            });
        },
        Close() {
            this.features = [];
            this.$emit('salvou');
            this.dialog = false;
        }
    },
    beforeUpdate(){
        if (!this.dialog){
            this.$emit('fechou');
        }
    },
    mounted() {

    }
}
</script>